import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import '../App.css';

function PersonaFormActions({ on_save, on_delete, saving, selected_id }) {
	return (
		<div className="admin-form-actions">
			<Button variant="primary" onClick={on_save} disabled={saving}>
				{saving ? <Spinner animation="border" size="sm" /> : (selected_id ? 'Save Changes' : 'Create Persona')}
			</Button>
			{selected_id ? (
				<Button variant="outline-danger" onClick={on_delete} disabled={saving}>
					Delete
				</Button>
			) : null}
		</div>
	);
}

export default PersonaFormActions;
